import React from 'react'
import VMSecureStateMappingForm from './VMSecureStateMappingForm';
import VMSecureStateCredentialForm from './VMSecureStateCredentialForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function VMSecureStateConfigListing(props) {

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={VMSecureStateMappingForm}
            CredentialsForm={VMSecureStateCredentialForm}
            componentName="Cloud Account Name"
            componentKey="cloudAccountName"
        />
    )
}